module.exports = __webpack_public_path__ + "img/renewalmain_mobile.a78e5e38.jpg";